import firebase from 'firebase/app'
import 'firebase/database'
import {GeoFire} from 'geofire'

var config = {
  apiKey: "AIzaSyD_uj1IhB9QL_7KSihK_GfrkvzhTQksWlY",
  authDomain: "rally-266f6.firebaseapp.com",
  databaseURL: "https://rally-266f6.firebaseio.com",
  projectId: "rally-266f6",
  storageBucket: "rally-266f6.appspot.com",
  messagingSenderId: "834997371981"
};

firebase.initializeApp(config);

export default firebase;

export const database = firebase.database();


export const geofireRacerLocations = new GeoFire(database.ref("geolocations"))



// WEBPACK FOOTER //
// ./src/firebase.js